import { apiClient } from './client'

export interface ExpressCompany {
  id: number
  name: string
  code: string
}

export const expressCompanyApi = {
  list: async (): Promise<ExpressCompany[]> => {
    const response = await apiClient.get<ExpressCompany[]>('/employee/express-companies')
    return response.data
  },
}
